/**
 * Client Product Restrictions Helper
 * FIXME
 * This logic must be moved into core-services (Partially or Completely)
 */
import { type Maybe, type ProductVariantFieldsFragment } from '../../__generated__/graphql-client-types';
import {
	type AlternateProductVariant,
	type RestrictionAlternate,
	type AlternateProduct as AlternateProductGraphType
} from '../../types/product.types';

/**
 * Returns true if the alternate product is the same as the product having restrictions, false otherwise.
 * Please refer to {@see https://github.com/FergDigitalCommerce/bwf-node-store/blob/master/src/app/views/store/pages/products/restrictions.js#L180}
 */
export const isAlternateProductSameAsProduct = (familyId?: number, alternatives?: Maybe<RestrictionAlternate>): boolean => {
	return typeof familyId !== 'undefined' && typeof alternatives !== 'undefined' && alternatives?.product.id === familyId;
};

/**
 * Resolve Alternate Variant by alternatives and selected variant.
 * Please refer to {@see https://github.com/FergDigitalCommerce/bwf-node-store/blob/master/src/app/views/store/pages/products/restrictions.js#L213}
 */
export const resolveAlternateProduct = (
	selectedVariant?: Maybe<ProductVariantFieldsFragment>,
	alternatives?: Maybe<RestrictionAlternate>
): Maybe<AlternateProduct> => {
	let variant: Maybe<AlternateProductVariant> = null;
	if (!alternatives) {
		return null;
	}
	if (alternatives.variantId) {
		variant = findAlternateVariantById(alternatives.product, alternatives.variantId);
	} else if (selectedVariant) {
		variant = findAlternateVariantByTitle(alternatives.product, selectedVariant.title);
	}
	return variant
		? {
				id: variant.id,
				image: variant.image,
				url: variant.url,
				priceInfo: variant.priceInfo,
				brandName: alternatives.product.brandName,
				productId: alternatives.product.productId,
				title: alternatives.product.title
		  }
		: null;
};

/**
 * Find alternate variant by id.
 */
export const findAlternateVariantById = (product: AlternateProductGraphType, id: number): Maybe<AlternateProductVariant> => {
	return product.variants.find((variant) => variant.id === id) || product.variants[0];
};

/**
 * Finds alternate variant by title.
 */
export const findAlternateVariantByTitle = (product: AlternateProductGraphType, title: string): Maybe<AlternateProductVariant> => {
	return product.variants.find((variant) => variant.title === title) || product.variants[0];
};

export type AlternateProduct = Exclude<AlternateProductVariant, 'title'> &
	Pick<AlternateProductGraphType, 'brandName' | 'productId' | 'title'>;
